import { isAnnouncementNotificationDetails } from "@scrile/api-provider/dist/api/AnnouncementsProvider";
import { Notification } from "@scrile/api-provider/dist/api/NotificationsProvider";
import emitter from "@/lib/emitter";
import { $t } from "@/lib/i18nHelpers";
import router from "@/router";
import { NotificationData } from "@/types";
import { EVENTS } from "@/const";

export default function(notification: Notification): NotificationData | false {
  if (isAnnouncementNotificationDetails(notification.details)) {
    emitter.emit(EVENTS.ANNOUNCEMENT_NEW_ANNOUNCEMENT, notification);

    return {
      text: $t("{0} has sent you a message", [$t("Newsletter")]),
      position: "top",
      timeout: 7000,
      image: {
        src: "/img/system-avatar.png",
      },
      onNotificationClick: () => router.push({ name: "announcements" }),
    };
  }
  return false;
}
